class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.querySelector("#CartDrawer-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#cart-icon-bubble");
		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");
		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(cartLink);
		});
		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
			this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add("animate", "active");
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = this.classList.contains("is-empty")
					? this.querySelector(".drawer__inner-empty")
					: document.getElementById("CartDrawer");
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".drawer__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		document.body.classList.add("overflow-hidden");
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden");
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute(
				"aria-controls",
				cartDrawerNote.nextElementSibling.id
			);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				!event.currentTarget.closest("details").hasAttribute("open")
			);
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector(".drawer__inner").classList.contains("is-empty") &&
			this.querySelector(".drawer__inner").classList.remove("is-empty");
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
			sectionElement.innerHTML = this.getSectionInnerHTML(
				parsedState.sections[section.id],
				section.selector
			);
		});

		setTimeout(() => {
			this.querySelector("#CartDrawer-Overlay").addEventListener(
				"click",
				this.close.bind(this)
			);
			this.open();
		});
	}

	getSectionInnerHTML(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: "cart-drawer",
				selector: "#CartDrawer",
			},
			{
				id: "cart-icon-bubble",
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: "cart-drawer",
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);

// Cart Drawer Recommended Product Dropdown Handler
(function () {
	document.addEventListener("click", function (e) {
		var trigger = e.target.closest(
			".cart-drawer-recommended__dropdown-trigger"
		);
		var option = e.target.closest(".cart-drawer-recommended__dropdown-option");
		var dropdown;

		// Handle Trigger Click
		if (
			trigger &&
			(dropdown = trigger.closest("[data-cart-drawer-recommended-dropdown]"))
		) {
			e.preventDefault();
			e.stopPropagation();
			var list = dropdown.querySelector(
				".cart-drawer-recommended__dropdown-list"
			);
			if (!list) return;

			if (list.hidden) {
				list.hidden = false;
				trigger.setAttribute("aria-expanded", "true");
			} else {
				list.hidden = true;
				trigger.setAttribute("aria-expanded", "false");
			}
			return;
		}

		// Handle Option Click
		if (
			option &&
			(dropdown = option.closest("[data-cart-drawer-recommended-dropdown]"))
		) {
			e.preventDefault();
			e.stopPropagation();
			if (option.classList.contains("is-disabled")) return;

			var list = dropdown.querySelector(
				".cart-drawer-recommended__dropdown-list"
			);
			var label = dropdown.querySelector(
				".cart-drawer-recommended__dropdown-label"
			);
			var form = dropdown.closest("form");
			var idInput = form
				? form.querySelector("[data-cart-drawer-recommended-id]")
				: null;
			var addBtn = form
				? form.querySelector(".cart-drawer-recommended__add")
				: null;
			var trigger = dropdown.querySelector(
				".cart-drawer-recommended__dropdown-trigger"
			);

			// Update Hidden Input
			if (option.dataset.variantId && idInput)
				idInput.value = option.dataset.variantId;

			// Update Label
			if (label) {
				var labelPrefix =
					trigger && trigger.getAttribute("aria-label")
						? trigger.getAttribute("aria-label")
						: "Size";
				label.textContent =
					labelPrefix +
					": " +
					(option.dataset.optionText || option.textContent.trim());
			}

			// Handle Selected State
			list
				.querySelectorAll(".cart-drawer-recommended__dropdown-option")
				.forEach(function (o) {
					o.classList.remove("is-selected");
				});
			option.classList.add("is-selected");

			// Update Button State
			if (addBtn) {
				var isDisabled = option.classList.contains("is-disabled");
				addBtn.disabled = isDisabled;
				var btnLabel = addBtn.querySelector(".button-label");
				var soldOut = addBtn.querySelector(".sold-out-message");

				if (btnLabel) btnLabel.classList.toggle("hidden", isDisabled);
				if (soldOut) soldOut.classList.toggle("hidden", !isDisabled);
			}

			// Close
			list.hidden = true;
			if (trigger) trigger.setAttribute("aria-expanded", "false");
			return;
		}

		// Close when clicking outside
		closeAll();
	});

	function closeAll() {
		document
			.querySelectorAll(
				"[data-cart-drawer-recommended-dropdown] .cart-drawer-recommended__dropdown-list"
			)
			.forEach(function (list) {
				list.hidden = true;
			});
		document
			.querySelectorAll(".cart-drawer-recommended__dropdown-trigger")
			.forEach(function (t) {
				t.setAttribute("aria-expanded", "false");
			});
	}
})();
